import getEnvironDomainUtil from 'ati-utils/getEnvironDomain';

export const getEnvironDomain = () => {
    let domain = getEnvironDomainUtil();

    if (window.config.devProxy) {
        domain = window.location.hostname.split('.').slice(-2).join('.');
    }
    return domain;
};
